import Link from 'next/link'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'

import translations from '../../../../../../../public/data/translations.json'

import { getUrlValues, getUrl } from 'SRC/modules/vehicleParts/utils/vehiclePartsUtils'

export const SeasonFilter = () => {
	const router = useRouter()

	const { t, lang } = useTranslation('common')

	const locale = lang?.toUpperCase() || 'ME'

	const urlValues = getUrlValues(router.query)

	const urlLjetnja = getUrl({ ...urlValues, season: 'ljetnja', page: 1 }, locale)
	const urlZima = getUrl({ ...urlValues, season: 'zimska', page: 1 }, locale)
	const urlUniverzalna = getUrl({ ...urlValues, season: 'all-season', page: 1 }, locale)

	console.log('urlLjetnja', urlLjetnja)

	return (
		<div className="vehicle-parts-price-sort">
			<div className="vehicle-parts-price-sort__buttons">
				<Link
					as={urlLjetnja.asUrl}
					href={urlLjetnja.href} passHref
				>
					<a className={`vehicle-parts-price-sort__button ${urlValues?.season === 'ljetnja' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/guma-ljetnja.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
						{t('Ljetnja')}
					</a>
				</Link>
				<Link
					as={urlZima.asUrl}
					href={urlZima.href} passHref
				>
					<a className={`vehicle-parts-price-sort__button ${urlValues?.season === 'zimska' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/guma-zimska.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
						{t('Zimska')}
					</a>
				</Link>
				<Link
					as={urlUniverzalna.asUrl}
					href={urlUniverzalna.href} passHref
				>
					<a className={`vehicle-parts-price-sort__button ${urlValues?.season === 'all-season' ? 'active' : ''}`}>
						<ReactSVG wrapper='span' src='/icons/guma-univerzalna.svg' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
						}} />
						{t('All season')}
					</a>
				</Link>
			</div>
		</div>
	)
}

